import React from "react";

const HomePageFooter = () => {
  return (
    <footer className="py-4 mt-auto flex justify-center">
      <nav className="flex flex-wrap justify-center gap-2 md:gap-4 text-center">
        <a
          href="https://tylt.money/privacy-policy"
          className="text-[8px] md:text-[10px] underline hover:text-gray-700 break-words"
          target="_blank"
          rel="noreferrer">
          Privacy Policy
        </a>
        <a
          href="https://tylt.money/cookie-policy"
          className="text-[8px] md:text-[10px] underline hover:text-gray-700 break-words"
          target="_blank"
          rel="noreferrer">
          Cookie Policy
        </a>
        <a
          href="https://tylt.money/terms-of-use"
          className="text-[8px] md:text-[10px] underline hover:text-gray-700 break-words"
          target="_blank"
          rel="noreferrer">
          Terms of Use
        </a>
        <a
          href="https://tylt.money/merchant-terms-of-use"
          className="text-[8px] md:text-[10px] underline hover:text-gray-700 break-words"
          target="_blank"
          rel="noreferrer">
          Merchant Terms of Use
        </a>
        <a
          href="https://tylt.money/risk-disclaimer"
          className="text-[8px] md:text-[10px] underline hover:text-gray-700 break-words"
          target="_blank"
          rel="noreferrer">
          Risk Disclaimer
        </a>
      </nav>
    </footer>
  );
};

export default HomePageFooter;
